import { Text } from "@chakra-ui/react"
import React from "react"
import { Address } from "~/interfaces/entities/Address"

interface Props {
  address: Address
}

const AddressNZ: React.FC<Props> = ({ address }) => {
  const { name, line1, line2, city, state, postcode } = address
  return (
    <>
      {!!name && <Text>{name}</Text>}
      {line1}, {!!line2 && `${line2},`} {city}, {state} {postcode}
    </>
  )
}

export default AddressNZ
